import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_NOTIFICATION = "getNotification"; 

//mutation types
export const SET_NOTIFICATION = "setNotification";

export default {
    state: {
        
        countNotification:"0",
        listTicket:null
        
    },
    getters: {
        /**
         * load count of Notification
         * @param state
         * @returns {*}
         */
        loadedCountNotification(state) {
            return state.countNotification;
        },
        /**
         * load list of Ticket
         * @param state
         * @returns {*}
         */
         loadedListTicket(state) {
            return state.listTicket;
        },
    },
    actions: {
       
        
        /**
         * Set the create notification
         * @param state
         * @param payload
         */
         [GET_NOTIFICATION](context,payload) {
            
            return new Promise((resolve, reject) => {

            httpHelper
                .getData('ticket-notification')
                .then((response) => {
                    context.commit(SET_NOTIFICATION,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        [SET_NOTIFICATION](state, payload) {
            state.countNotification = payload.ticketCount;
            state.listTicket = [...payload.tickets];
        }
    }
};